// extracted by mini-css-extract-plugin
export var numpadContainer = "_rf-1";
export var phoneButton = "_rf-0";